module.exports = __webpack_public_path__ + "img/logo.2143742b.png";